/* global swal moment */
import './style.less';
import employeeModalTemplate from 'modals/employeesSearch/index.html';
import EmployeeModalController from 'modals/employeesSearch';
import { keyBy } from 'lodash';

export default function($log, $stateParams, $q, $timeout, $uibModal, ApiClass, ProfileClass) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;
  vm.activate = activate;

  vm.profile_uid = $stateParams.id;
  const company_id = ProfileClass.company_id;

  vm.selectEmployees = team => {
    const filterEmployees = team.members.map(({ email }) => email);
    $uibModal
      .open({
        backdrop: 'static',
        animation: true,
        size: 'lg',
        template: employeeModalTemplate,
        controller: EmployeeModalController(filterEmployees),
        controllerAs: 'employeeModalCtrl'
      })
      .result.then(users => {
        team.dropdownBtn = true;
        const memberIds = users.map(({ profile_uid }) => profile_uid);
        return ApiClass.usersTeamsIdPut({ id: team.uuid }, { members: memberIds }, { queryParams: { manage: true } });
      })
      .then(() => {
        team.dropdownBtn = false;
        activate();
      })
      .catch(error => {
        team.dropdownBtn = false;
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  vm.updateStatus = (team, active) => {
    team.dropdownBtn = true;
    ApiClass.companiesIdTypeTypeIdPatch({ manage: true, id: company_id, type: 'teams', type_id: team.uuid }, { active })
      .then(() => {
        team.active = active;
        team.dropdownBtn = false;
      })
      .catch(error => {
        team.dropdownBtn = false;
        $log.error(error);
        throw error;
      });
  };

  vm.remove = (team, member) => {
    member.removeBtn = true;
    ApiClass.usersIdTypeTypeIdDelete({ id: member.profile_uid, type: 'teams', type_id: team.uuid }, null, {
      queryParams: { manage: true }
    })
      .then(() => activate())
      .catch(error => {
        member.removeBtn = false;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    $log.debug('USER TEAMS LOADED');
    vm.loaded = false;
    vm.error = {};
    delete vm.teams;

    ApiClass.usersIdTypeGet({ id: $stateParams.id, type: 'teams', manage: false })
      .then(({ data: { items, profiles } }) => {
        vm.profilesDict = keyBy(profiles, 'profile_uid');

        for (let team of items) {
          for (let i = 0; i < team.members.length; i++) {
            team.members[i] = vm.profilesDict[team.members[i]];
            if (team.leaders.includes(team.members[i].profile_uid)) team.members[i].leader = true;
          }
        }

        vm.teams = items;
        vm.loaded = true;
      })
      .catch(error => {
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/teams/get/index.js